import * as React from "react";
import {
	AppBar,
	Box,
	Stack,
} from "@mui/material";
import Logo from "../../../assets/vepay-logo-full.svg";
import ClientContract from "./ClientContract";

export default function Onboarding() {
	return (
		<Box sx={{ flexGrow: 1, background: "#F9F9FB", minHeight: "100vh" }}>
			<AppBar position="static">
				<Stack
					direction="row"
					alignContent="center"
					justifyContent="center"
					sx={{ m: 2 }}
				>
					<img src={Logo} alt="VePay" style={{ width: '20%' }} />
				</Stack>
			</AppBar>
			<ClientContract />
		</Box>
	);
}
